<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <div class="custom-toolbar">
    <div class="toolbar-content">
      <ion-buttons slot="start" style="width: 44px;"></ion-buttons>

      <div class="title-group">
        <div class="title-main">{{ titulo }}</div>
        <div class="title-sub">Seleccione una opción de la lista</div>
      </div>

      <ion-buttons slot="end">
        <ion-button (click)="dismiss()" class="icon-btn">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <div class="search-wrapper">
    <ion-searchbar placeholder="Buscar..." (ionInput)="search($event)" [debounce]="250" mode="ios" class="custom-searchbar">
    </ion-searchbar>
  </div>
</ion-header>

<ion-content class="premium-content-bg ion-padding modal-content">

  <div class="premium-card item-list-card">
    <ion-list class="item-list" lines="none">
      <ion-item *ngFor="let item of filteredItems" button (click)="selectItem(item)" class="modern-item" lines="none">

        <ion-label>
          <!-- Display first 4 non-null values -->
          <h2 *ngIf="getDisplayValues(item)[0]" class="main-text">{{ getDisplayValues(item)[0] }}</h2>
          <div class="sub-texts">
            <p *ngFor="let val of getDisplayValues(item) | slice:1">{{ val }}</p>
          </div>
        </ion-label>

        <!-- Toggle for multiple selection - handled by row click -->
        <ion-toggle *ngIf="isMultiple" slot="end" [checked]="isChecked(item)" style="pointer-events: none;"></ion-toggle>

        <!-- Chevron for single selection -->
        <ion-icon *ngIf="!isMultiple" name="chevron-forward-outline" slot="end" color="medium"></ion-icon>
      </ion-item>

      <div *ngIf="filteredItems.length === 0" class="empty-state">
        <p>No se encontraron resultados</p>
      </div>
    </ion-list>
  </div>

</ion-content>

<ion-footer *ngIf="isMultiple" class="ion-no-border">
  <ion-toolbar class="footer-toolbar">
    <ion-button expand="block" class="confirm-btn" (click)="confirmSelection()" [disabled]="selectedItems.length === 0">
      Confirmar Selección
    </ion-button>
  </ion-toolbar>
</ion-footer>
